const getBrowserScrollbarWidth = () => {
  if (typeof window === 'undefined') return undefined

  const cssVariable = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue('--scrollbar-width')

  if (cssVariable) return cssVariable

  const scrollDiv = document.createElement('div')
  scrollDiv.style.cssText =
    'width: 100px;height: 100px;overflow: scroll;position: absolute;top: -9999px;'
  document.body.appendChild(scrollDiv)
  const scrollbarWidth = `${scrollDiv.offsetWidth - scrollDiv.clientWidth}px`
  document.body.removeChild(scrollDiv)

  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth)
  return scrollbarWidth
}

let savedScrollPosition = { x: 0, y: 0 }

const scrollLock = (lock: boolean, options?: { preservePosition?: boolean }): undefined => {
  if (!document || !document.body || !document.body.parentElement) return undefined

  const preservePosition = options?.preservePosition ?? false

  // Only apply scroll lock on non-lg viewports (< 1024px) unless preservePosition is enabled
  const isLgOrAbove = typeof window !== 'undefined' && window.innerWidth >= 1024

  if (isLgOrAbove && !preservePosition) {
    // Clean up scroll lock on lg+ viewports
    document.body.parentElement.style.overflow = ''
    document.body.parentElement.style.paddingRight = ''
    document.body.classList.remove('u-lock')
    document.documentElement.classList.remove('u-scroll-locked')
    return undefined
  }

  if (lock) {
    // Save current scroll position
    if (preservePosition) {
      savedScrollPosition = {
        x: window.scrollX || window.pageXOffset,
        y: window.scrollY || window.pageYOffset,
      }
    }

    document.body.parentElement.style.overflow = 'hidden'
    document.body.parentElement.style.paddingRight = getBrowserScrollbarWidth() || ''
    document.body.classList.add('u-lock')
    document.documentElement.classList.add('u-scroll-locked')

    // Lock scroll position for better control
    if (preservePosition) {
      document.body.style.position = 'fixed'
      document.body.style.top = `-${savedScrollPosition.y}px`
      document.body.style.left = `-${savedScrollPosition.x}px`
      document.body.style.right = '0'
    }
  } else {
    document.body.parentElement.style.overflow = ''
    document.body.parentElement.style.paddingRight = ''
    document.body.classList.remove('u-lock')
    document.documentElement.classList.remove('u-scroll-locked')

    // Restore scroll position
    if (preservePosition) {
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      window.scrollTo(savedScrollPosition.x, savedScrollPosition.y)
    }
  }

  return undefined
}

export default scrollLock
export { getBrowserScrollbarWidth }
